import { createFileRoute, redirect } from "@tanstack/react-router";
import {
	addLocaleToPathname,
	buildPath,
	DEFAULT_LOCALE,
	resolveLocaleForPath,
} from "@/lib/i18n/locale";

// Former URL, kept so existing links and search results land on the new page.
export const Route = createFileRoute("/{-$locale}/expertise")({
	loader: ({ location, serverContext }) => {
		const locale = resolveLocaleForPath(location.pathname, serverContext);
		const basePath = "/expo-migration";
		const targetPathname =
			locale === DEFAULT_LOCALE
				? basePath
				: addLocaleToPathname(basePath, locale);
		throw redirect({
			href: buildPath(targetPathname, location.searchStr, location.hash),
			statusCode: 301,
		});
	},
	component: () => null,
});
